export default function Hourglass() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0018 19.9997L12.8803 14.0651C11.8222 13.1834 11.2932 12.7425 10.9129 12.2021C10.5759 11.7232 10.3256 11.1889 10.1735 10.6235C10.0018 9.98532 10.0018 9.29666 10.0018 7.91934V3.33301M20.0018 19.9997L27.1233 14.0651C28.1813 13.1834 28.7104 12.7425 29.0907 12.2021C29.4277 11.7232 29.678 11.1889 29.8301 10.6235C30.0018 9.98532 30.0018 9.29666 30.0018 7.91934V3.33301M20.0018 19.9997L12.8803 25.9342C11.8222 26.816 11.2932 27.2568 10.9129 27.7973C10.5759 28.2761 10.3256 28.8104 10.1735 29.3759C10.0018 30.014 10.0018 30.7027 10.0018 32.08V36.6663M20.0018 19.9997L27.1233 25.9342C28.1814 26.816 28.7104 27.2568 29.0907 27.7973C29.4277 28.2761 29.678 28.8104 29.8301 29.3759C30.0018 30.014 30.0018 30.7027 30.0018 32.08V36.6663M6.66846 3.33301H33.3351M6.66846 36.6663H33.3351"
        stroke="#B91D7B"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
